import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { userSuspendedService } from './../../../api/services/payway';
import { getRegion } from './../../../utils/Region';
import { apiCall, updateSwaggerManager } from 'api';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';

export const useUserSuspended = (isEmailRegister, isUserGetInfo) => {
  const user = useSelector(state => state.user);
  const userSuspendedInfo = useSelector(
    state => state.userSuspendedInfo?.getUserInfo,
  );
  const { hour_refresh } = useSelector(
    selectMetadataKeyByRegion('suspended_refresh_hours_time'),
  );
  const [isUserSuspended, setIsUserSuspended] = useState(false);
  let tickTimestamp;
  const { firstNode } = useMenuRedirect();

  const getStatusUser = async withTimeout => {
    try {
      const { data: userSuspendedResp } = await userSuspendedService();
      if (userSuspendedResp.status !== 200) throw new Error();

      let currentUserStatus;
      //Casteo si nos responde con un true/false pero son strings
      if (typeof userSuspendedResp?.response?.isSuspended === 'string') {
        currentUserStatus =
          userSuspendedResp?.response?.isSuspended.toLowerCase() === 'true';
      } else {
        currentUserStatus = userSuspendedResp?.response?.isSuspended;
      }
      if (!withTimeout) return setIsUserSuspended(currentUserStatus);

      //CON TIMEOUT
      if (isUserSuspended === true && currentUserStatus === false) {
        localStorage.removeItem('selectProfile');
        localStorage.removeItem('getUserInfo');
        localStorage.removeItem('isEmailRegister');
        window.location.replace(`/${getRegion()}/${firstNode}`);
        return;
      }
      setIsUserSuspended(currentUserStatus);
    } catch (error) {
      if (isUserSuspended) {
        setIsUserSuspended(false);
      }
    }
  };

  useEffect(
    () => {
      if (!user?.hasOwnProperty('is_user_logged_in')) return;
      if (user?.is_user_logged_in === 0 && !isEmailRegister) return;
  
      const apiParams = {
        user_id: isUserGetInfo?.id_usuario,
      };
      if (isUserGetInfo?.region_nombre) {
        apiParams.region = isUserGetInfo?.region_nombre;
      }
      updateSwaggerManager(apiCall, apiParams);
      getStatusUser(false);
    },
    [
      user?.is_user_logged_in,
      isEmailRegister,
      userSuspendedInfo?.region_nombre,
      userSuspendedInfo?.id_usuario,
    ],
  );

  useEffect(
    () => {
      if (!user?.hasOwnProperty('is_user_logged_in')) return;
      if (user?.is_user_logged_in === 0 && !isEmailRegister) return;
     
      const hourToRefresh = hour_refresh || 1;
      let userSuspendedTick = setInterval(() => {
        getStatusUser(true);
        tickTimestamp = new Date().getTime();
      }, hourToRefresh * 3600000);

      return () => {
        clearInterval(userSuspendedTick);
      };
    },
    [tickTimestamp, isUserSuspended, user?.is_user_logged_in, isEmailRegister],
  );

  return {
    isUserLoggedIn: user?.is_user_logged_in || 0,
    isUserSuspended,
  };
};
